'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScalableContent = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  transform: scale(', ')\n'], ['\n  transform: scale(', ')\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ScalableContent = exports.ScalableContent = _styledComponents2.default.section(_templateObject, function (_ref) {
  var scale = _ref.scale;
  return scale;
});
//# sourceMappingURL=ScalableBox.styled.js.map